import clsx from 'clsx';
import React from 'react';
import { Tab, TabList, TabPanel } from 'react-tabs';

import Tabs from '@/src/components/common/Elements/Tabs/Tabs';
import { cn } from '@/src/util/ui';

import ActivityLogs from './AcitvityLogs/ActivityLogs';
import Comments from './Comments/Comments';
import CommentsTabHeader from './Comments/CommentTabHeader';
import FileDetails from './FileDetails/FileDetails';
import TreatmentsTabHeader from './Treatment/Elements/TreatmentTabHeader/TreatmentTabHeader';
import Treatment from './Treatment/Treatment';

// Tab List Classes
const tabListClasses = cn(
  'tw-flex tw-items-center',
  'tw-min-h-[52px]',
  'tw-m-0 !tw-py-0 !tw-px-[20px]',
  'tw-shadow-[0px_-1px_0px_0px_#EEE_inset,_0px_3px_3px_0px_rgba(65,74,79,0.05)'
);
// Tab Item Classes
const tabItemClasses = cn('!tw-px-[10px] !tw-py-[15px] tw-mr-[20px]');
// Tab Container Classes
const tabContainerClasses = cn('tw-h-full tw-max-h-[calc(100%-60px)] tw-p-0');

export type FullScreenSetting = {
  isContainerFullScreen: boolean;
  isViewerFullScreen: boolean;
  heights?: {
    fullScreenHeight: string;
    containerFullScreenHeight: string;
    defaultHeight: string;
  };
};

export const setContainerHeight: (
  isContainerFullScreen: FullScreenSetting['isContainerFullScreen'],
  isViewerFullScreen: FullScreenSetting['isViewerFullScreen'],
  heights: FullScreenSetting['heights']
) => string = (isContainerFullScreen, isViewerFullScreen, heights) => {
  const {
    fullScreenHeight = 'tw-h-[calc(100vh-100px)] if_File_Viewer_isFullscreen',
    containerFullScreenHeight = 'tw-h-[calc(100vh-215px)] emailThread_is_Fullscreen',
    defaultHeight = 'tw-h-full is_default_height',
  } = heights;

  if (isContainerFullScreen && isViewerFullScreen) {
    return fullScreenHeight;
  }
  if (isViewerFullScreen) {
    return fullScreenHeight;
  }
  if (isContainerFullScreen) {
    return containerFullScreenHeight;
  }
  return defaultHeight;
};

const InfoPanel = ({
  projectId,
  fileEntry,
  activeTab,
  setActiveTab,
  FileDetailsComponent = FileDetails,
  treatmentComponent = null,
  treatmentsTabHeaderComponent = null,
}) => {
  return (
    <Tabs
      className={clsx('detailsTab tw-h-full')}
      selectedIndex={activeTab}
      onSelect={(index) => setActiveTab(index)}
    >
      <TabList className={tabListClasses}>
        <Tab className={tabItemClasses}>
          <CommentsTabHeader />
        </Tab>
        <Tab className={tabItemClasses}>
          {treatmentsTabHeaderComponent ? (
            treatmentsTabHeaderComponent
          ) : (
            <TreatmentsTabHeader documentId={fileEntry.file.id} inboxDocumentId={fileEntry.id} />
          )}
        </Tab>
        <Tab className={tabItemClasses}>Details</Tab>
        <Tab className={tabItemClasses}>Activities</Tab>
      </TabList>

      <TabPanel className={tabContainerClasses}>
        <Comments projectId={projectId} fileEntry={fileEntry} />
      </TabPanel>

      <TabPanel className={tabContainerClasses}>
        {treatmentComponent ? treatmentComponent : <Treatment fileEntry={fileEntry} />}
      </TabPanel>

      <TabPanel className={tabContainerClasses}>
        <FileDetailsComponent fileEntry={fileEntry} />
      </TabPanel>

      <TabPanel className={tabContainerClasses}>
        <ActivityLogs projectId={projectId} fileEntry={fileEntry} />
      </TabPanel>
    </Tabs>
  );
};

export default InfoPanel;
